import React, { useContext } from "react";
import { useMediaQuery, useTheme } from '@mui/material';
import AnimateFrom from "../../components/animations/AnimateFrom";
import VersionInfo from './VersionInfo';
import ParkITLogo from '../../assets/parkIT.svg?react';
import position from '../../styles/position';
import styles from './styles';
import { TenantSelector } from "./TenantSelector";
import { SessionContext } from "../../utility/useSession";

export interface ITenantSelectorProps {
}

export const TenantSelectorPage: React.FC<ITenantSelectorProps> = ({

}) => {
  const session = useContext(SessionContext);
  const theme = useTheme();
  const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));

  const handleReset = () => {
    session.logout();
  };

  return <>
    <AnimateFrom style={{ opacity: 0, zoom: 0 }}>
      <div style={isLargeDevice ? { ...position.fixedFill, ...styles.background } : { ...styles.background, ...styles.backgroundSmall }}></div>
      <div style={isLargeDevice ? { ...position.absoluteFill, } : {}}>
        <div style={isLargeDevice == true ? styles.sideBarWrapper : styles.sideBarWrapperSmall}>
          <div style={isLargeDevice == true ? styles.sideBar : styles.sideBarSmall}>
            <TenantSelector onReset={handleReset} />
          </div>
        </div >
        {/* spacer div to prevent issue with footer covering login button */}
        <div style={{ height: 88 }}></div>
        <div style={styles.footer}>
          <div style={isLargeDevice ? styles.webFooter : styles.tabletFooter}>
            <ParkITLogo style={{ transform: "scale(0.5)", marginLeft: -12, paddingTop: 20 }} />
          </div>
        </div>
      </div>
    </AnimateFrom>

    <div style={{ position: "fixed", right: 5, bottom: 5, color: "black", opacity: 0.5 }}>
      <VersionInfo />
    </div>
  </>
}
